export default "__VITE_ASSET__a4686ebe__"